import { HttpErrorResponse } from '@angular/common/http';
import { ApiService } from './../services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { QueryParam } from './../query-param';
import { Config } from './../config';
import { Title } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PinDailogComponent } from '../pin-dailog/pin-dailog.component';
import { MobileDialogComponent } from '../mobile-dialog/mobile-dialog.component';
import { Account } from '../account';
import { MsgDialogComponent } from '../msg-dialog/msg-dialog.component';
import { LoginDialogComponent } from '../login-dialog/login-dialog.component';

@Component({
  selector: 'app-myaccount',
  templateUrl: './myaccount.component.html',
  styleUrls: ['./myaccount.component.css']
})
export class MyaccountComponent implements OnInit {
  isSubCancel: boolean = false;
  constructor(
    private activatedRoute: ActivatedRoute,
    private apiService: ApiService,
    private router: Router,
    private titleService: Title,
    private modal: NgbModal

  ) { }

  active: any = 'Active';

  queryParam!: QueryParam;
  gameConfig: Config = {} as Config;

  account: Account = {} as Account;

  number: any;

  operatorIdsForSL = ['2014', '2096'];

  alertMsg = '';
  isShow = false;
  buttonDisabled = false;
  isShowMyAccountTable: Boolean = true;
  unSubMessage: string = '';

  subData: any = {};
  ngOnInit() {

    let storageName = this.apiService.getItem();
    console.log("Storage Name---------------->", storageName)
    // localStorage.setItem('storageName', storageName);
    this.queryParam = JSON.parse(
      localStorage.getItem(storageName) || 'undefined'
    );

    this.getQueryParam();
    // this.getStatus()
    if (this.queryParam.id == '6' && this.queryParam.biller == 'TPAY' && this.queryParam.operator == '9073') {
      this.queryParam.mobileNumber = 0;
    }

    if (this.queryParam.lang == 'PL') {
      this.active = 'Aktywny'
    } else if (this.queryParam.lang == 'PT') {
      this.active = 'Ativa'
    } else {
      this.active = 'Active'
    }

    if (this.queryParam.id == "240" || this.queryParam.id == "414") {
      this.isShow = true;
    }

    if (this.queryParam.id == "526") {
      this.isShow = true;
    }

    if ((this.queryParam.id == '519' || this.queryParam.id == '530') && this.queryParam.biller.toLowerCase == ('COMVIVA').toLowerCase) {
      if (this.queryParam.mobileNumber == 0) {
        this.buttonDisabled = true;
      }
    }


    this.getConfigData(this.queryParam.id, this.queryParam.lang, this.queryParam.theme);
    window.scrollTo(0, document.body.scrollHeight / 2);

    this.getAccount(this.queryParam.id, this.queryParam.lang);
    // this.getConditionalDialogBox();

    if (this.queryParam.id == "536" && this.queryParam.serviceId == "1331") {
      this.getSubDataByServiceId(this.queryParam.id, this.queryParam.serviceId);
    }


    this.getUnSubMessage(); //For Portal 528

  }
  getStatus() {
    let url = "http://wap.matrixads.in/mglobopay/qanawatKSAUnsubGeneric?msisdn=" + this.queryParam.msisdn;
    this.apiService.unSubMobileResponseFORCOMVIVA447(url).subscribe(
      (res: any) => {
        console.log(res)
        if (res == false) {
          this.active = 'INACTIVE'
        }
        else {
          this.active = 'ACTIVE'
        }
      })
  }

  getAccount(portalId: any, lang: any) {
    this.apiService.getAccount(portalId, lang).subscribe(
      (response: any) => {
        console.log("*****", response)
        this.account = response;
      },
      (err: HttpErrorResponse) => {
        console.log(err);
      }
    );
  }

  getGameConfig() {
    this.gameConfig.sliderName = 'slider';
    this.gameConfig.title = 'A SELECTION OF THE BEST';
    this.gameConfig.description =
      'Rump biltong buffalo kielbasa bresaola strip steak frankfurter bacon tenderloin brisket picanha chuck meatball. Rump biltong buffalo kielbasa bresaola strip steak frankfurter bacon enderloin brisket picanha chuck meatball';

    this.gameConfig.imageList = [
      'assets/images/carousel-1.png',
      'assets/images/slider-2.png',
      'assets/images/slider-3.png'
    ];
  }

  getVideozConfig() {
    this.gameConfig.sliderName = 'noslider';
    this.gameConfig.title = 'Video Lounge';
    this.gameConfig.description =
      'Video app format that offers a multi-lingual videos with an option to upload videos and you can enjoy unlimited super features';

    this.gameConfig.imageList = ['assets/images/carousel-1 copy.png'];
  }

  getVideoConfig() {
    this.gameConfig.sliderName = 'videoSlider';
    this.gameConfig.title = 'A SELECTION OF THE BEST';
    this.gameConfig.description =
      'Rump biltong buffalo kielbasa bresaola strip steak frankfurter bacon tenderloin brisket picanha chuck meatball. Rump biltong buffalo kielbasa bresaola strip steak frankfurter bacon enderloin brisket picanha chuck meatball';

    this.gameConfig.imageList = [
      'assets/images/silde4.png',
      'assets/images/slider-5.png'
    ];

    console.log('this.videoConfig', this.gameConfig.imageList);
  }

  getYogaConfig() {
    this.gameConfig.sliderName = 'slider';
    this.gameConfig.title = 'A SELECTION OF THE BEST';
    this.gameConfig.description =
      'Rump biltong buffalo kielbasa bresaola strip steak frankfurter bacon tenderloin brisket picanha chuck meatball. Rump biltong buffalo kielbasa bresaola strip steak frankfurter bacon enderloin brisket picanha chuck meatball';

    this.gameConfig.imageList = [
      'assets/images/yoga1.png',
      'assets/images/yoga2.png',
      'assets/images/yoga4.png'
    ];
  }

  getConfigData(data: any, lang: any, theme: any) {
    this.apiService.getConfigData(data, lang, theme).subscribe(
      (response: any) => {
        this.gameConfig = response;
        this.titleService.setTitle(this.gameConfig.header1);
      },
      (err: HttpErrorResponse) => {
        console.log(err);
      }
    );
  }

  unsub() {
    this.isSubCancel = true;

    this.getConditionalDialogBox()
  }

  openMsgDialog(): void {

    const modalRef = this.modal.open(MsgDialogComponent, { size: 'md', backdrop: 'static', keyboard: false });
    modalRef.result.then((data) => {
    }, (reason) => {
    });
  }

  openDialog(): void {

    const modalRef = this.modal.open(MobileDialogComponent, { size: 'md', backdrop: 'static', keyboard: false });
    modalRef.result.then((data) => {
    }, (reason) => {
    });
  }

  portalIds = ['6', '16', '32', '48', '87', '149', '152', '170', '197',
    '200', '286', '295', '296', '298', '305', '320', '322',
    '325', '327', '334', '335', '364', '370', '371', '375', '376'];

  operatorIds = ['2032', '2150', '2209', '2022', '2049', '2050', '2025', '4464', '2217',
    '2104', '2105', '5573', '8966', '9073', '9071', '2009', '2010', '2032', '2150', '2209',
    '9038', '2022', '2028', '2029', '2049', '2050', '2212', '2213', '2214', '2215', '2216',
    '2217', '2218', '2103', '7803', '2100', '2151', '9032', '9041', '2032', '2150', '2209',
    '9038', '2050', '2032', '2150', '2209', '9038', '2216', '8966', '2026', '2032', '2150',
    '2209', '9038', '2032', '2150', '2209', '2049', '2104', '5573', '2009', '2010', '2032',
    '2150', '2209', '2049', '2050', '2216', '2104', '5573', '2001', '9038', '8966', '8899',
    '8903', '8966', '2215', '2216', '2217', '2217', '5573', '8903', '8966', '9041', '2032',
    '2150', '2209', '9038', '2029', '2213', '2217', '2104', '5573', '2009', '2010', '2032',
    '2150', '2209', '9038', '2028', '2049', '2050', '2213', '2214', '4464', '2215', '2216',
    '9042', '2104', '2105', '5573', '8899', '8903', '8966', '2032', '2150', '2032', '2150',
    '2032', '2150', '2209', '9038', '2215', '2216', '2104', '2105', '5573', '2032', '2150',
    '2209', '9038', '2215', '2216', '2104', '2105', '5573', '2032', '2032', '2150', '2209',
    '9038', '2049', '2050', '2215', '2216', '2104', '2105', '5573', '9071', '2032', '2150',
    '2209', '9038', '2049', '2050', '2215', '2216', '2104', '2105', '5573', '2010', '2032',
    '2150', '2209', '9038', '2029', '2049', '2050', '2215', '2216', '2104', '2105', '5573',
    '9071', '2032', '2150', '2209', '9038', '2032', '2150', '2209', '9038', '2104', '5573',
    '2216', '2104', '5573', '2104', '2032', '2150', '2209', '9038', '2049', '2050', '2049',
    '2050', '2049', '2050', '2032', '2150', '2209', '9038', '2032', '2150', '2209', '9038',
    '2010', '2032', '2150', '2209', '9038', '2010', '8899', '8903', '8966', '8899', '8903',
    '8966', '2032', '2150', '2209', '9038', '2032', '2150', '2209', '9038', '2032', '2150',
    '2209', '9038', '5573', '2026', '2216', '2216', '9073', '2049', '2050', '2032', '2150',
    '2209', '9038', '2032', '2150', '2209', '9038', '2001', '2215', '2102', '5518', '9047',
    '2102', '5518', '9047', '2104'];

  getConditionalDialogBox() {

    console.log('entered function')

    if ((this.queryParam.id === '90' || this.queryParam.id === '478') && this.queryParam.biller.toLowerCase() === 'MOBIXONE'.toLowerCase()) {

      this.queryParam.sub = false;
      this.apiService.unSubscribedMOBIXONE(this.queryParam).subscribe(
        (res: any) => {
          console.log(res)
          if (res.status == 'success') {
            this.alertMsg = this.account.subcribed;
            this.queryParam.status = "IN ACTIVE";

            this.queryParam.sub = false;
            this.queryParam.popup = true;
            //  let storageName = this.queryParam.id+this.queryParam.operator+this.queryParam.biller;
            localStorage.setItem(this.apiService.getItem(), JSON.stringify(this.queryParam));
          } else {
            this.alertMsg = this.account.unsubscribed;
          }

        },
        (err: HttpErrorResponse) => {
          this.alertMsg = "Error while unsubscrib user";
          console.log(err);
        }
      );
    } else if ((this.queryParam.id == '427') && this.queryParam.biller.toLowerCase() == "MOBIXONE".toLowerCase()) {
      // if(this.queryParam.serviceId == undefined || this.queryParam.serviceId == ''){
      //   this.queryParam.serviceId = "1368";
      // }
      this.apiService.getGenericUnsub2(this.queryParam.serviceId, this.queryParam.msisdn, this.queryParam.subscription_id, this.queryParam.request_ref).subscribe(
        (res: any) => {
          if (res == true) {
            this.alertMsg = "unsubcribed Successfully";
            this.queryParam.status = "INACTIVE";
            this.active = "INACTIVE";
          } else {
            this.alertMsg = "Invalid subcription";
          }

        },
        (err: HttpErrorResponse) => {
          this.alertMsg = "Error while unsubscrib user";
          console.log(err);
        }
      );
      // }else if((this.queryParam.id === '427') && this.queryParam.biller.toLowerCase() === 'MOBIXONE'.toLowerCase()){
      //   this.queryParam.sub = false;
      //   let url = "http://wap.matrixads.in/mglobopay/genericUnsub?msisdn="+this.queryParam.msisdn+"&id="+this.queryParam.id+"&operator="+this.queryParam.operator+"&serviceId="+this.queryParam.serviceId+"&biller="+this.queryParam.biller+"&subscription_id="+this.queryParam.subscription_id+"&requestRef="+this.queryParam.request_ref;
      //   console.log("URL:",url)
      //   this.apiService.unSubscribedMobixOne427(url).subscribe(
      //     (res: any) => {

      //       if(res.status == 'true'){
      //         this.alertMsg = this.account.subcribed;
      //         this.queryParam.status = "IN ACTIVE";

      //         this.queryParam.sub = false;
      //         this.queryParam.popup = true;
      //       //  let storageName = this.queryParam.id+this.queryParam.operator+this.queryParam.biller;
      //         localStorage.setItem(this.apiService.getItem(), JSON.stringify(this.queryParam));
      //       }else{
      //         this.alertMsg = this.account.unsubscribed;
      //       }

      //     },
      //     (err: HttpErrorResponse) => {
      //       this.alertMsg = "Error while unsubscrib user";
      //       console.log(err);
      //     }
      //   );
    } else if (this.queryParam.id === '447' && this.queryParam.biller === 'COMVIVA') {
      this.queryParam.sub = false;
      let url = "http://wap.innovate360.in/mglobopay/comvivaZnKwUnSub/" + this.queryParam.mobileNumber;

      this.queryParam.sub = false;
      this.apiService.unSubMobileResponseFORCOMVIVA447(url).subscribe(
        (res: any) => {

          if (res.status == 'success') {
            this.alertMsg = this.account.subcribed;
            this.queryParam.status = "IN ACTIVE";
          } else {
            this.alertMsg = this.account.unsubscribed;
          }

        },
        (err: HttpErrorResponse) => {
          this.alertMsg = "Error while unsubscrib user";
          console.log(err);
        }
      );
    } else if (this.queryParam.id === '481' && this.queryParam.biller === 'ONE97') {

      this.queryParam.sub = false;
      let url = "https://wap.matrixads.in/mglobopay/uaeONSUNSub?msisdn=" + this.queryParam.mobileNumber + "&serviceId=" + this.queryParam.serviceId;

      this.queryParam.sub = false;
      this.apiService.unSubMobileResponseFORCOMVIVA447(url).subscribe(
        (res: any) => {

          if (res == true) {
            this.alertMsg = this.account.subcribed;
            this.queryParam.status = "IN ACTIVE";
            this.router.navigate(["home"], {
              queryParams: {
                id: this.queryParam.id,
                lang: this.queryParam.lang,
                operator: this.queryParam.operator,
                biller: this.queryParam.biller,
                msisdn: 0,
                type: this.queryParam.type
              }
            });
          }
          else {
            this.alertMsg = this.account.unsubscribed;
          }

        },
        (err: HttpErrorResponse) => {
          this.alertMsg = "Error while unsubscrib user";
          console.log(err);
        }
      );
    }
    /* else  if((this.queryParam.id === '298' || this.queryParam.id === '334') && this.queryParam.biller === 'TPAY' && this.queryParam.operator === "8966"){
      this.queryParam.sub = false;
      this.apiService.unSubscribedTpayService(this.queryParam.mobileNumber, "42004", this.queryParam.id).subscribe(
        (res: any) => {

          if(res.operationStatusCode != undefined){
            if(res.operationStatusCode == 0) {
              this.queryParam.operatorCode = "42004";
              let storageName = this.queryParam.id+this.queryParam.operator+this.queryParam.biller;
              localStorage.setItem(storageName, JSON.stringify(this.queryParam));
              this.openPinDialog();
            }
          }else{
            this.alertMsg = res.errorMessage;
          }

        },
        (err: HttpErrorResponse) => {
          console.log(err);
        }
      );
    } */

      else if (this.queryParam.id === '16' && this.queryParam.biller === 'TRENDYTECH') {
        this.queryParam.sub = false;
        let url = `https://wap.globocom.info/mglobopay/genericUnsub?msisdn=${this.queryParam.mobileNumber}&serviceId=${this.queryParam.serviceId}&consentId=_blank`;
      
        this.queryParam.sub = false;
        this.apiService.unSubscribedtrendy(url).subscribe(
          (res: any) => {
            if (res === true) {
              this.alertMsg = "Unsubscribed Successfully";
              this.queryParam.status = "INACTIVE";
              this.active = "INACTIVE";
            } else {
              this.alertMsg = "Invalid subscription";
            }
          },
          (err: HttpErrorResponse) => {
            this.alertMsg = "Error while unsubscribing user";
            console.log(err);
          }
        );
      }
      

    else if (this.queryParam.id === '297' && this.queryParam.biller.toLowerCase() === ('MediaWorld').toLowerCase() && this.queryParam.operator === "8938") {
      this.queryParam.sub = false;
      let url = "http://wap.matrixads.in/mglobopay/mediaWorldDeactivation?msisdn=" + this.queryParam.mobileNumber + '&serviceid=' + this.queryParam.serviceId;
      this.apiService.unSubMobileResponseFORCOMVIVA447(url).subscribe(
        (res: any) => {

          if (res == true) {
            this.alertMsg = this.account.subcribed;
            this.queryParam.status = "IN ACTIVE";

            // this.queryParam.sub = false;
            // this.queryParam.popup = true;
            //  let storageName = this.queryParam.id+this.queryParam.operator+this.queryParam.biller;
            localStorage.setItem(this.apiService.getItem(), JSON.stringify(this.queryParam));
          } else {
            // this.alertMsg = res.errorMessage;
            this.alertMsg = "You are not subscribed"
            this.queryParam.status = "In ACTIVE"

          }

        },
        (err: HttpErrorResponse) => {
          console.log(err);
        }
      );
    } else if (this.queryParam.id === '499' && this.queryParam.biller.toLowerCase() === ('All').toLowerCase() && this.queryParam.operator === "2096") {
      this.openMsgDialog();

    }
    else if (this.queryParam.id === '416' && this.queryParam.biller.toLowerCase() === ('MediaWorld').toLowerCase() && this.queryParam.operator === "2215") {
      this.queryParam.sub = false;
      // debugger;
      if (this.queryParam.serviceId == undefined || this.queryParam.serviceId == '') {
        this.queryParam.serviceId = "11166";
      }
      let url = "http://wap.matrixads.in/mglobopay/mediaWorldDeactivation?msisdn=" + this.queryParam.mobileNumber + '&serviceid=' + this.queryParam.serviceId;
      this.apiService.unSubMobileResponseFORCOMVIVA447(url).subscribe(
        (res: any) => {

          if (res == true) {
            this.alertMsg = this.account.subcribed;
            this.queryParam.status = "IN ACTIVE";

            // this.queryParam.sub = false;
            // this.queryParam.popup = true;
            //  let storageName = this.queryParam.id+this.queryParam.operator+this.queryParam.biller;
            localStorage.setItem(this.apiService.getItem(), JSON.stringify(this.queryParam));
          } else {
            // this.alertMsg = res.errorMessage;
            this.alertMsg = "You are not subscribed"
            this.queryParam.status = "In ACTIVE"

          }

        },
        (err: HttpErrorResponse) => {
          console.log(err);
        }
      );
    } else if ((this.queryParam.id === '6') && this.queryParam.biller === 'TPAY' && this.queryParam.operator === "9071") {
      this.queryParam.sub = false;
      let url = "http://wap.matrixads.in/mglobopay/CheckSubscriptionStatusGamesWorld?msisdn=" + this.queryParam.mobileNumber
      this.apiService.unSubMobileResponseFORCOMVIVA447(url).subscribe(
        (res: any) => {

          if (res == true) {
            this.alertMsg = this.account.subcribed;
            this.queryParam.status = "IN ACTIVE";
            this.active = "IN ACTIVE";
            // this.queryParam.sub = false;
            // this.queryParam.popup = true;
            //  let storageName = this.queryParam.id+this.queryParam.operator+this.queryParam.biller;
            localStorage.setItem(this.apiService.getItem(), JSON.stringify(this.queryParam));
          } else {
            // this.alertMsg = res.errorMessage;
            this.alertMsg = "You are not subscribed"
            this.queryParam.status = "In ACTIVE"
            this.active = "ACTIVE";

          }

        },
        (err: HttpErrorResponse) => {
          console.log(err);
        }
      );
    } else if ((this.queryParam.id === '6') && this.queryParam.biller === 'TPAY' && this.queryParam.operator === "9073") {
      this.queryParam.sub = false;
      let url = "http://wap.matrixads.in/mglobopay/cancelationContractForTpay/" + this.queryParam.mobileNumber + "/63407/GAMESWORLD"
      this.apiService.unSubMobileResponseFORCOMVIVA447(url).subscribe(
        (res: any) => {

          if (res.operationStatusCode == 0) {
            this.alertMsg = this.account.subcribed;
            this.queryParam.status = "IN ACTIVE";
            this.active = "In Active";
            localStorage.setItem(this.apiService.getItem(), JSON.stringify(this.queryParam));
          } else {
            // this.alertMsg = res.errorMessage;
            this.alertMsg = this.account.unsubscribed
            this.queryParam.status = "In ACTIVE"
            this.active = "ACTIVE";


          }

        },
        (err: HttpErrorResponse) => {
          console.log(err);
        }
      );
    } else if ((this.queryParam.id === '298') && this.queryParam.biller === 'TPAY' && this.queryParam.operator === "8966") {
      this.queryParam.sub = false;
      let url = "http://wap.matrixads.in/mglobopay/cancelationContractForTpay/" + this.number + "/42004/GamesGala"
      this.apiService.unSubMobileResponseFORCOMVIVA447(url).subscribe(
        (res: any) => {

          if (res.operationStatusCode == 0) {
            this.alertMsg = this.account.subcribed;
            this.queryParam.status = "IN ACTIVE";
            this.active = "In Active";
            localStorage.setItem(this.apiService.getItem(), JSON.stringify(this.queryParam));
          } else {
            // this.alertMsg = res.errorMessage;
            this.alertMsg = this.account.unsubscribed
            this.queryParam.status = "In ACTIVE"
            this.active = "ACTIVE";


          }

        },
        (err: HttpErrorResponse) => {
          console.log(err);
        }
      );
    } else if ((this.queryParam.id == '502' || '503') && this.queryParam.biller == 'Tetragram') {
      this.apiService.getGenericUnsub5(this.queryParam.msisdn, this.queryParam.serviceId, this.queryParam.product_id).subscribe((res: any) => {
        if (res == true) {
          this.alertMsg = this.account.subcribed;
          this.active = 'In Active'
        } else {
          this.alertMsg = this.account.unsubscribed;
        }
      });
    } else if ((this.queryParam.id === '322') && this.queryParam.biller === 'TPAY' && this.queryParam.operator === "8903") {
      this.queryParam.sub = false;
      let url = "http://wap.matrixads.in/mglobopay/cancelationContractForTpay/" + this.number + "/42003/GamesTune"
      this.apiService.unSubMobileResponseFORCOMVIVA447(url).subscribe(
        (res: any) => {

          if (res.operationStatusCode == 0) {
            this.alertMsg = this.account.subcribed;
            this.queryParam.status = "IN ACTIVE";
            this.active = "In Active";
            localStorage.setItem(this.apiService.getItem(), JSON.stringify(this.queryParam));
          } else {
            // this.alertMsg = res.errorMessage;
            this.alertMsg = this.account.unsubscribed
            this.queryParam.status = "In ACTIVE"
            this.active = "ACTIVE";
          }

        },
        (err: HttpErrorResponse) => {
          console.log(err);
        }
      );
    } else if (["16", "90", "440", "310", "390", "373", "494"].includes(this.queryParam.id) && this.queryParam.biller.toLowerCase() == "MONDIOMEDIA".toLowerCase()) {
      // console.log("lavdeeeeeeeeeeeeeeeeeeeee-e------------------")

      let url = "http://wap.globocom.info/mglobopay/mondioNgPlatformUnsub?serviceid=" + this.queryParam.serviceId + "&uuid=" + this.queryParam.uuid;

      this.apiService.unSubMobileResponseFORCOMVIVA447(url).subscribe(
        (res: any) => {
          // debugger;
          if (res == false) {
            this.alertMsg = this.account.subcribed;
            this.queryParam.status = "IN ACTIVE";
          } else {
            this.alertMsg = this.account.unsubscribed;
          }

        },
        (err: HttpErrorResponse) => {
          this.alertMsg = "Error while unsubscrib user";
          console.log(err);
        }
      );
    } else if (['491'].includes(this.queryParam.id) && this.queryParam.biller.toLowerCase() == "MONDIOMEDIA".toLowerCase()) {
      let url = "http://wap.globocom.info/mglobopay/mondioNgPlatformUnsub?serviceid=" + 1292 + "&msisdn=" + this.queryParam.msisdn + "&mode=" + "APP";

      this.apiService.unSubMobileResponseFORCOMVIVA447(url).subscribe(
        (res: any) => {
          // debugger;
          if (res == false) {
            this.alertMsg = this.account.subcribed;
            this.queryParam.status = "NIEAKTYWNY";
          } else {
            this.alertMsg = this.account.unsubscribed;
          }

        },
        (err: HttpErrorResponse) => {
          this.alertMsg = "Error while unsubscrib user";
          console.log(err);
        }
      );
    } else if (["543", "544"].includes(this.queryParam.id) && this.queryParam.biller.toLowerCase() == "DIRECTDCB".toLowerCase()) {

      let url = "http://wap.matrixadz.com/mglobopay/deactivaterNcellWap?serviceid=" + this.queryParam.serviceId + "&msisdn=" + this.queryParam.msisdn;

      this.apiService.unSubMobileResponseFORCOMVIVA447(url).subscribe(
        (res: any) => {
          // debugger;
          if (res == true) {
            this.alertMsg = this.account.subcribed;
            this.queryParam.status = "IN ACTIVE";
          } else {
            this.alertMsg = this.account.unsubscribed;
          }

        },
        (err: HttpErrorResponse) => {
          this.alertMsg = "Error while unsubscrib user";
          console.log(err);
        }
      );
    } else if ((this.queryParam.id == '375') && (this.queryParam.biller == "QANAWAT") && (this.queryParam.operator == '8966')) {
      let url = "http://wap.matrixads.in/mglobopay/qanawatKSAUnsubGeneric?msisdn=" + this.queryParam.msisdn + "&serviceId=" + this.queryParam.serviceId;

      this.apiService.unSubMobileResponseFORCOMVIVA447(url).subscribe(
        (res: any) => {
          console.log(res);
          if (res == true) {
            this.alertMsg = 'You are unsubscribed succesfully';
            this.queryParam.status = "IN ACTIVE";

            let newparams = {
              biller: "QANAWAT",
              id: "375",
              lang: "EN",
              operator: "8966",
              blocker: "1",
              msisdn: this.queryParam.msisdn,
            }
            this.active = "INACTIVE"
            // console.log('SHBHAM:', this.queryParam)
            this.router.navigate(['/home'], { queryParams: newparams });
            // this.openDialog()
          } else {
            this.alertMsg = 'Not able to unsubscribe';
            this.active = "INACTIVE"
          }

        },
        (err: HttpErrorResponse) => {
          this.alertMsg = "Error while unsubscrib user";
          console.log(err);
        }
      );
    } else if ((this.queryParam.id == '369') && this.queryParam.biller.toLowerCase() == "fcc".toLowerCase()) {
      let url = "http://wap.matrixads.in/mglobopay/fccUnsubUrlwap/" + this.queryParam.msisdn + "/" + this.queryParam.serviceName;

      this.apiService.unSubMobileResponseFORCOMVIVA447(url).subscribe(
        (res: any) => {
          // debugger;
          if (res == false) {
            this.alertMsg = this.account.subcribed;
            this.queryParam.status = "IN ACTIVE";
          } else {
            this.alertMsg = this.account.unsubscribed;
          }

        },
        (err: HttpErrorResponse) => {
          this.alertMsg = "Error while unsubscrib user";
          console.log(err);
        }
      );
    } else if ((this.queryParam.id == '401') && this.queryParam.biller.toLowerCase() == "ALTRUS".toLowerCase()) {
      if (this.queryParam.serviceId == undefined || this.queryParam.serviceId == '') {
        this.queryParam.serviceId = "1198";
      }
      // debugger;
      let url = "http://wap.matrixads.in/mglobopay/altrusUnsubMsisdn?msisdn=" + this.queryParam.msisdn + "&serviceid=" + this.queryParam.serviceId + "&lang=en=";

      this.apiService.unSubMobileResponseFORCOMVIVA447(url).subscribe(
        (res: any) => {
          // debugger;
          if (res == true) {
            this.alertMsg = this.account.subcribed;
            this.queryParam.status = "IN ACTIVE";
          } else {
            this.alertMsg = this.account.unsubscribed;
          }

        },
        (err: HttpErrorResponse) => {
          this.alertMsg = "Error while unsubscrib user";
          console.log(err);
        }
      );
    } else if ((this.queryParam.id == '490' || this.queryParam.id == '427' || this.queryParam.id == '526') && this.queryParam.biller.toLowerCase() == "SLADigital".toLowerCase()) {
      if ((this.queryParam.serviceId == undefined || this.queryParam.serviceId == '') && this.queryParam.id == '490') {
        this.queryParam.serviceId = "1319";
      } else if ((this.queryParam.serviceId == undefined || this.queryParam.serviceId == '') && this.queryParam.id == '427') {
        this.queryParam.serviceId = "1321";
      } else if ((this.queryParam.serviceId == undefined || this.queryParam.serviceId == '') && this.queryParam.id == '526') {
        this.queryParam.serviceId = "1313";
      }

      let url = "http://wap.matrixads.in/mglobopay/genericUnsub?msisdn=" + this.queryParam.msisdn + "&serviceId=" + this.queryParam.serviceId;

      this.apiService.unSubMobileResponseFORCOMVIVA447(url).subscribe(
        (res: any) => {
          // debugger;
          if (res == true) {
            if (this.queryParam.lang == 'PT') {
              this.alertMsg = this.account.subcribed;
              this.queryParam.status = "IN ACTIVE";
              this.active = "INATIVA"
            } else {
              this.alertMsg = this.account.subcribed;
              this.queryParam.status = "IN ACTIVE";
              this.active = "INACTIVE"
            }
          } else {
            this.alertMsg = this.account.unsubscribed;
          }
        },
        (err: HttpErrorResponse) => {
          this.alertMsg = "Error while unsubscrib user";
          console.log(err);
        }
      );
    } else if ((this.queryParam.id == '484') && this.queryParam.biller.toLowerCase() == "MOBIXONE".toLowerCase()) {
      if ((this.queryParam.serviceId == undefined || this.queryParam.serviceId == '') && this.queryParam.id == '484') {
        this.queryParam.serviceId = "1324";
      }

      // let url = "http://wap.matrixads.in/mglobopay/genericUnsub?msisdn="+this.queryParam.msisdn+"&serviceId="+this.queryParam.serviceId;

      this.apiService.getGenericUnsub3(this.queryParam.msisdn, this.queryParam.serviceId, this.queryParam.subscription_id, this.queryParam.request_ref).subscribe(
        (res: any) => {
          // debugger;
          if (res == true) {
            this.alertMsg = this.account.subcribed;
            this.queryParam.status = "IN ACTIVE";
          } else {
            this.alertMsg = this.account.unsubscribed;
          }
        },
        (err: HttpErrorResponse) => {
          this.alertMsg = "Error while unsubscrib user";
          console.log(err);
        }
      );
    } else if (this.portalIds.includes(this.queryParam.id) && this.queryParam.biller === 'TPAY' && this.operatorIds.includes(this.queryParam.operator)) {
      if (this.queryParam.mobileNumber == 0) {
        this.queryParam.popup = true;
        this.openLoginDialog();
      } else {
        let url = "http://wap.globocom.info/mglobopay/tpayLoginByUsername?msisdn=" + this.queryParam.msisdn + "&pin=" + this.queryParam.pin + "&operatorId=" + this.queryParam.operator;
        this.getMobilePINRes(this.queryParam.mobileNumber, this.queryParam.pin, this.queryParam.operator, url)
      }
    } else if ((this.queryParam.id == '532') && this.queryParam.biller.toLowerCase() == "Sunych".toLowerCase()) {
      if (this.queryParam.serviceId == undefined || this.queryParam.serviceId == '') {
        this.queryParam.serviceId = "1368";
      }
      this.apiService.getGenericUnsub(this.queryParam.serviceId, this.queryParam.mobileNumber).subscribe(
        (res: any) => {

          if (res == true) {
            this.alertMsg = "unsubcribed Successfully";
            this.queryParam.status = "INACTIVE";
            this.active = "INACTIVE";
          } else {
            this.alertMsg = "Invalid subcription";
          }

        },
        (err: HttpErrorResponse) => {
          this.alertMsg = "Error while unsubscrib user";
          console.log(err);
        }
      );
    } else if ((this.queryParam.id == '519' || this.queryParam.id == '530') && this.queryParam.biller.toLowerCase() == "COMVIVA".toLowerCase()) {
      console.log("SERVICE", this.queryParam.serviceId)
      console.log("SERVICE", this.queryParam.msisdn)
      let url = "http://wap.matrixads.in/mglobopay/genericUnsub?serviceId=" + this.queryParam.serviceId + "&msisdn=" + this.queryParam.msisdn;

      this.apiService.unSubMobileResponseFORCOMVIVA447(url).subscribe(
        (res: any) => {
          // debugger;
          if (res == true) {
            this.alertMsg = this.account.subcribed;
            this.queryParam.status = "IN ACTIVE";
            this.active = "IN ACTIVE";

          } else {
            this.alertMsg = this.account.unsubscribed;
          }
        },
        (err: HttpErrorResponse) => {
          this.alertMsg = "Error while unsubscrib user";
          console.log(err);
        }
      );
    } else if (this.queryParam.id == '536' && this.queryParam.biller == 'Mobimind' && this.queryParam.operator == '2029') {
      window.location.href = 'http://dg.mobi-mind.net/SubInfo?ServiceId=99929916&MSISDN=' + this.queryParam.mobileNumber
      // this.apiService.getGenericUnsub(this.queryParam.serviceId,this.queryParam.mobileNumber).subscribe((res:any)=>{
      //   if (res == true) {
      //     this.alertMsg = this.account.subcribed;
      //     this.queryParam.status = "IN ACTIVE";
      //   } else {
      //     this.alertMsg = this.account.unsubscribed;
      //   }
      // });
    } else if (this.queryParam.id == '563' && this.queryParam.biller == 'Mobimind' && this.queryParam.operator == '2025') {
      window.location.href = 'http://dg.mobi-mind.net/SubInfo?ServiceId=99915706&MSISDN=' + this.queryParam.mobileNumber
      // this.apiService.getGenericUnsub(this.queryParam.serviceId,this.queryParam.mobileNumber).subscribe((res:any)=>{
      //   if (res == true) {
      //     this.alertMsg = this.account.subcribed;
      //     this.queryParam.status = "IN ACTIVE";
      //   } else {
      //     this.alertMsg = this.account.unsubscribed;
      //   }
      // });
    } else {
      let url = "http://wap.matrixads.in/mglobopay/genericUnsub?msisdn=" + this.queryParam.msisdn + "&serviceId=" + this.queryParam.serviceId;
      this.apiService.unSubMobileResponseFORCOMVIVA447(url).subscribe(
        (res: any) => {
          if (res == true) {
            this.alertMsg = this.account.subcribed;
            this.queryParam.status = "IN ACTIVE";
          } else {
            this.alertMsg = this.account.unsubscribed;
          }
        });
    }

  }

  getMobilePINRes(mobileNumber: number, pinNumber: number, operatorId: string, url: any) {
    this.apiService.getMobilePINResponse(url).subscribe(
      (response: any) => {
        console.log('Mobile Reponse ===============', response);
        if (response !== null) {
          this.queryParam.pin = pinNumber;
          this.queryParam.sub = true;
          this.queryParam.mobileNumber = mobileNumber;
          let storageName = this.queryParam.id + this.queryParam.operator + this.queryParam.biller;
          localStorage.setItem(storageName, JSON.stringify(this.queryParam));
        }
        else {
          this.openLoginDialog();
        }
      },
      (err: HttpErrorResponse) => {
        console.log(err);
      }
    );
  }

  openLoginDialog(): void {

    const modalRef = this.modal.open(LoginDialogComponent, { size: 'md', backdrop: 'static', keyboard: false });
    modalRef.result.then((data) => {
    }, (reason) => {
    });
  }


  openPinDialog(): void {

    const modalRef = this.modal.open(PinDailogComponent, { size: 'md', backdrop: 'static', keyboard: false });
    modalRef.result.then((data) => {
    }, (reason) => {
    });
  }

  getSubDataByServiceId(portalId: any, serviceId: any) {
    if (portalId == 536) {
      if (serviceId == null) {
        serviceId = 1331;
      }

      this.apiService.getSubDataByServiceId(serviceId, this.queryParam.msisdn).subscribe((res: any) => {
        this.subData = res;
        console.log("LOG", this.subData);
      })
    }


  }

  getUnSubMessage() {
    let unSubKeyword, unSubKeyword2, unSubKeyword3, shortCode;
    if (this.queryParam.id == '528' && this.queryParam.biller == 'ACTEL') {
      switch (this.queryParam.operator) {
        case '2214':
          unSubKeyword = 'UNSUB GN';
          shortCode = '98054';
          break;
        case '4464':
          unSubKeyword = 'UNSUB GNVA';
          shortCode = '94302';
          break;
        case '2213':
          unSubKeyword = 'UNSUB GNV';
          shortCode = '94005';
          break;
        case '2162':
          unSubKeyword = '06';
          shortCode = '3768';
          break;
      }
      this.unSubMessage = "To unsubscribe from GamesNova send " + unSubKeyword + " to " + shortCode;
      this.isShowMyAccountTable = false;
    } else if (this.queryParam.id == '536' && this.queryParam.biller == 'Mobimind' && this.queryParam.lang == 'AR') {
      switch (this.queryParam.operator) {
        case '8899':
          unSubKeyword = 'U 1';
          shortCode = '802213';
          break;
        case '8966':
          unSubKeyword = 'U 1';
          shortCode = '709701';
          break;
        case '8903':
          unSubKeyword = 'U 310';
          shortCode = '670611';
          break;
        case '9043':
          unSubKeyword = 'U 63';
          shortCode = '300346';
          break;
      }
      this.unSubMessage = " لإلغاء الاشتراك في GAMESOLUTELY ، أرسل " + unSubKeyword + " إلى " + shortCode;
      this.isShowMyAccountTable = false;
    }
    else if (this.queryParam.id == '536' && this.queryParam.biller == 'Mobimind' && this.queryParam.lang == 'EN') {
      if (this.queryParam.operator == '2029') {
        this.isShowMyAccountTable = true;
      } else {
        switch (this.queryParam.operator) {
          case '2022':
            unSubKeyword = 'STOP 1';
            shortCode = '1421';
            break;
          case '2028':
            unSubKeyword = 'STOP 2';
            shortCode = '50279';
            break;
        }
        this.unSubMessage = "To unsubscribe from GAMESOLUTELY send " + unSubKeyword + " to " + shortCode
        this.isShowMyAccountTable = false;
      }
    } else if ((this.queryParam.operator == '2123' || this.queryParam.operator == '2135') && (this.queryParam.biller == 'Infovas' || this.queryParam.biller == 'ILUMIN8')) {
      switch (this.queryParam.id) {
        case '482':
          unSubKeyword = 'STOP FLICKS';
          shortCode = '394';
          break;
        case '547':
          unSubKeyword = 'STOP GAMEZ';
          shortCode = '394';
          break;
        case '81':
          unSubKeyword = 'STOP GAMESVD';
          unSubKeyword2 = 'STOP GAMESVW';
          unSubKeyword3 = 'STOP GAMESVM'
          shortCode = '20027';
          break;
        case '382':
          unSubKeyword = 'STOP VDAD';
          unSubKeyword2 = 'STOP VDAW';
          unSubKeyword3 = 'STOP VDAM';
          shortCode = '20028'
      }
      if (this.queryParam.operator == '2135' && this.queryParam.biller == 'ILUMIN8') {
        this.unSubMessage = "To unsubscribe the service For Daily Customer send sms " + unSubKeyword + " to " + shortCode + " -- " + "For Weekly Customer send " + unSubKeyword2 + " to " + shortCode + " -- " + "For Monthly Customer send " + unSubKeyword3 + " to " + shortCode;
      } else {
        this.unSubMessage = "To unsubscribe the service send sms " + unSubKeyword + " to " + shortCode;

      }
      this.isShowMyAccountTable = false;
    } else if (this.queryParam.id == '427' && this.queryParam.biller == 'MOBIXONE' && this.queryParam.lang == 'EN') {
      if (this.queryParam.operator == '2014') {
        this.unSubMessage = 'To manage your subscriptions dial *123#'
        this.isShowMyAccountTable = true;
      }
    }

  }

  getQueryParam() {
    this.activatedRoute.queryParams.subscribe(params => {

      if (typeof params['msisdn'] != undefined && params['msisdn'] != null) {
        this.queryParam.msisdn = params['msisdn'];
        this.queryParam.mobileNumber = params['msisdn'];

      }

      if (typeof params['service_id'] != undefined && params['service_id'] != null) {
        this.queryParam.serviceId = params['service_id'];
      }
      if (typeof params['blocker'] != undefined && params['blocker'] != null) {
        this.queryParam.blocker = params['blocker'];
      }

      if (typeof params['biller'] != undefined && params['biller'] != null) {
        this.queryParam.biller = params['biller'];
      }
      // if (typeof params['serviceid'] != undefined && params['serviceid'] != null) {
      //   this.queryParam.serviceId = params['serviceid'];
      // }

    });
  }

}
